<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline"  @keyup.enter="handleOk()">
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="标签名称">
                <a-input  v-model="queryParam.installLabelName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="添加时间">
                <a-range-picker
                  v-model="queryParam.tiem"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  @change="onChange1"
                  @ok="onOk1"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="添加人">
                <a-input  v-model="queryParam.createByName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" style="text-align: right">
              <a-button type="primary" htmlType="submit" @click="handleOk(1)">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearValues">清空</a-button>
            </a-col>
          </a-row>
          <a-divider/>
          <a-row>
            <a-col :span="4" :offset="20" style="text-align: right">
              <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
              <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
              <!--<a-button type="danger" icon="delete" style="width: 120px;" @click="delByIds(selectedRowKeys)">删除</a-button>-->
              <!--</a-dropdown>-->
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-tabs
        default-active-key="1"
        :tab-position="top"
        @prevClick="callback"
        @nextClick="callback"
        @change="callback"
        v-show="isTrue == 1"
      >
        <a-tab-pane v-for="i in labelList" :key="i.installType" :tab="i.installName">
          <a-table
            size="default"
            ref="table"
            :columns="columns"
            :data-source="i.installList[current-1]"
            :pagination = false
            bordered
          >
            <span slot="action" slot-scope="text, record">
              <a v-if="viewLabelList" @click="handleShow(record)">查看</a>
              <a-divider v-if="viewLabelList" type="vertical"/>
              <span v-if="editEnabel">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical"/>
                <a v-if="record.forbiddenStatus==1" @click="showState(record.installLabelId,record.forbiddenStatus)">启用</a>
                <a v-else @click="showState(record.installLabelId,record.forbiddenStatus)">禁用</a>
              </span>
              <a-divider v-if="deleteEnable && editEnabel" type="vertical"/>
              <a v-if="deleteEnable" @click="delByIds(record.installLabelId)">删除</a>
              <!--<a-divider type="vertical" />-->
              <!--<a v-if="record.forbiddenStatus==1" @click="showState(record.channelId,record.forbiddenStatus)">启用</a>-->
              <!--<a v-else @click="showState(record.channelId,record.forbiddenStatus)">禁用</a>-->
            </span>
          </a-table>
          <a-pagination
            showQuickJumper
            showSizeChanger
            :pageSizeOptions="pageSizeOptions"
            :pageSize.sync="pageSize"
            @showSizeChange="onShowSizeChange"
            :total="i.installLabel.length"
            v-model="current"
            @change="getdataList4"
            :showTotal="total => `总共 ${total} 条`"
            style="margin-top: 20px;text-align: end"
          />
        </a-tab-pane>
      </a-tabs>
      <div v-show="isTrue == 2" style="text-align: center">
        <a-divider></a-divider>
        <span>暂无数据</span>
      </div>
      <noticead-modal ref="modal" @ok="handleOk(1)"/>
    </a-card>
    <no-authority v-if="!queryList"></no-authority>
  </div>
</template>
<script>

  import { STable } from '@/components'
  import { deleteInstallLabel,queryInstallLabel,forbiddenInstallLabel,enableInstallLabel } from '@/api/master/LabelManagement'
  import NoticeadModal from './modules/LabelmanagementModal.vue'
  import NoAuthority from '../enterprise/NoAuthority'
  import { checkPermission } from '@/utils/permissions'
  import moment from 'moment'

  export default {
    name: 'TableList',
    components: {
      STable,
      NoticeadModal,
      NoAuthority
    },
    data () {
      return {
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          createStartTime:'',
          createEndTime:''
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            width:'80px',
            align:'center',
          }, {
            title: '操作',
            dataIndex: 'action',
            width:'80px',
            scopedSlots: { customRender: 'action'},
          }, {
            title: '标签名称',
            dataIndex: 'installLabelName',
            align:'center',
          }, {
            title: '添加时间',
            dataIndex: 'createTime',
            align:'center',
          }, {
            title: '添加人',
            dataIndex: 'createByName',
            align:'center',
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        // loadData: parameter => {
        //   return queryInstallLabel(Object.assign(parameter, this.queryParam))
        // },
        labelList:[],
        isTrue:1,
        // 分页
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total:0,
        current:1,
        pageSize:10,
        addEnable: checkPermission('master:labelList:add'),
        editEnabel: checkPermission('master:labelList:editAndForbidden'),
        deleteEnable: checkPermission('master:labelList:delete'),
        queryList: checkPermission('master:LabelManagement:query:list'),
        viewLabelList: checkPermission('master:labelList:view'),
      }
    },
    filters: {},
    async created () {
      // document.body.addEventListener('keyup', e => {
      //   if (e.keyCode == 13) {
      //     this.handleOk()
      //   }
      // })
      queryInstallLabel().then(res=>{
        console.log(res.rows)
        this.labelList = res.rows
        for(let i in this.labelList){
          // console.log('aa',this.labelList[i].installLabel)
          this.labelList[i]['installList'] = this.arr(this.labelList[i].installLabel,this.pageSize)
        }
        console.log(this.labelList)
      })
    },
    // destroyed () {
    //   document.body.removeEventListener('keyup', e => {})
    // },
    methods: {
      moment,
      onShowSizeChange(current, pageSize) {
        this.pageSize = pageSize;
        this.handleOk(current)
      },
      getdataList4(value = 1) {
        this.handleOk(value)
      },
      arr(arr,num){
        let newArr = []
        for(var i=0;i<arr.length;i+=num){
          newArr.push(arr.slice(i,i+num))
        }
        return newArr
      },
      onChange1(value, dateString) {
        console.log('Selected Time: ', value);
        console.log('Formatted Selected Time: ', dateString);
        this.queryParam.createStartTime=dateString[0]
        this.queryParam.createEndTime=dateString[1]
      },
      onChange2(date,dateString) {
        // console.log(dateString)
        this.queryParam.endTime=dateString
      },
      handleChange1 (value) {
        // console.log(`selected ${value}`)
        this.queryParam.importance=value
      },
      clearValues() {
        this.queryParam={}
        this.queryParam.createStartTime=''
        this.queryParam.createEndTime=''
        console.log(this.queryParam)
      },
      onOk1(value) {
        // console.log('onOk: ', value);
      },
      handleAdd () {
        this.$refs.modal.add()
      },
      handleShow(record){
        this.$refs.modal.edit(record,1)
      },
      handleEdit (record) {
        this.$refs.modal.edit(record)
      },
      handleOk (value) {
        this.current = value
        let that = this.queryParam
        queryInstallLabel({installLabelName:that.installLabelName,createByName:that.createByName,createStartTime:that.createStartTime,createEndTime:that.createEndTime}).then(res=>{
          this.labelList = res.rows
          for(let i in this.labelList){
            // console.log('aa',this.labelList[i].installLabel)
            this.labelList[i]['installList'] = this.arr(this.labelList[i].installLabel,this.pageSize)
          }
          // console.log(that)
          if(this.labelList.length == 0){
            this.isTrue = 2
          }else{
            this.isTrue = 1
          }
        })
      },
      callback(val) {
        // console.log(val);
        this.current = 1
      },
      showState (installLabelId, forbiddenStatus) {
        if (forbiddenStatus == 0) {
          forbiddenInstallLabel({ 'installLabelId': installLabelId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk(this.current)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (forbiddenStatus == 1) {
          enableInstallLabel({ 'installLabelId': installLabelId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk(this.current)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      delByIds (id) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            deleteInstallLabel({ 'installLabelId': id }).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.handleOk(that.current)
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }
    },
    watch: {
      /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
    }
  }
</script>

<style scoped>
  .twobtn{
    background-color: #409EFF;
    color: white;
    width: 110px;
    font-size: 15px;
  }
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap; padding: 4px 16px;}
</style>
